export interface Policy {
    policyNumber?: string;
    country?: string;
    language?: string;
    productType?: string;
    errorMessage?: string;
    campaign?: string;
    agentCode?: string;
    clientKey?: string;
    promo?: string;
    paymentStatus?: string;
    paymentSuccess?: false;
    savedForLaterToken?: string;

    policySME?: PolicySME;
    payment?: Payment;
}

export interface Payment {
    paymentCreditCardName?: string;
    paymentReferenceNumber?: string;
    paymentReferenceNumberToken?: string;
    auth_code?: string;
}

export interface PolicySME {
    site?: string;
    riskNumber?: number;
    inceptionDate?: string;
    expiryDate?: string;

    officePack?: boolean;
    shopPack?: boolean;

    buildingSI?: number;
    contentsSI?: number;
    situationTurnoverCode?: string;
    occupationCode?: number;
    occupationDesc?: string;
    insuredPerson?: string;
    insuredPersonBirthDate?: string;
    numberOfEmployees?: number;
    annualWages?: number;

    locationAddress1?: string;
    locationAddress2?: string;
    locationArea?: string;
    locationAreaDesc?: string;
    locationDistrict?: string;
    locationDistrictDesc?: string;
    locationAccumulationRegister?: string;
    locationUnitNo?: string;
    locationFloorNo?: string;
    locationBuildingName?: string;
    locationBuildingStreetNo?: string;
    locationPostCode?: string;
    locationCountry?: string;

    totalGrossAmount?: number;
    totalDiscount?: number;
    totalDueAmount?: number;

    subsidyAmount?: number;

    applicant?: Applicant;
    policyPremium?: PolicyPremium;
    premiumItems?: PremiumItem[];

    // added
    businessType?: string;
    interestedParty?: InterestedParty;
    ownershipType?: string;
}

export interface Applicant {
    fullName?: string;
    dateOfBirth?: string;
    hkId?: string;
    mobileNoCountryCode?: string;
    mobileNo?: string;
    email?: string;
    idType?: string;

    clientKey?: string;
    clientType?: string;
    additionalName?: string;
    uen?: string;
    forAttentionOf?: string;

    applicantAddress1?: string;
    applicantAddress2?: string;
    applicantArea?: string;
    applicantAreaDesc?: string;
    applicantDistrict?: string;
    applicantDistrictDesc?: string;
    applicantAccumulationRegister?: string;
    applicantUnitNo?: string;
    applicantFloorNo?: string;
    applicantBuildingName?: string;
    applicantBuildingStreetNo?: string;
    applicantPostCode?: string;
    applicantCountry?: string;

    declarationAcceptanceCheckBox?: boolean;
    majorExclusionsAcceptanceCheckBox?: boolean;
    termsAndConditionsAcceptanceCheckBox?: boolean;
    personalInformationCollectionAcceptanceCheckBox?: boolean;
    sameAsInsuredAddress: boolean;
    hasInterestedParty?: string;
    directMarketing?: boolean;
}

export interface PremiumItem {
    planCode?: string;
    planName?: string;
    premium?: number;
    annualPremium?: number;
    levy?: number;
    ecLevy?: number;
    totalPremium?: number;
    discount?: number;
    discountRate?: number;
    insuredCommissionDiscount?: number;
    insuredCommissionDiscountRate?: number;
}

export interface InterestedParty {
    customerType?: string;
    corporateName?: string;
    surname?: string;
    givenName?: string;
    fin?: string;
    gender?: string;
    dob?: string;
    role?: string;

    locationAddress1?: string;
    locationAddress2?: string;
    locationUnitNo?: string;
    locationFloorNo?: string;
    locationPostCode?: string;
    locationCountry?: string;
}

export interface PolicyPremium {
    planCode?: string;
    planName?: string;
    premium?: number;
    annualPremium?: number;
    levy?: number;
    ecLevy?: number;
    gst?: number;
    totalPremium?: number;
    discount?: number;
    discountRate?: number;
    insuredCommissionDiscount?: number;
    insuredCommissionDiscountRate?: number;
}

export const initialPolicy: Policy = {
    productType: 'BIZ',
    country: 'SGP',
    agentCode: '01001354',
    campaign: '',
    policySME: {
        // buildingSI: 0,
        // contentsSI: 0,
        situationTurnoverCode: '1',
        // numberOfEmployees: 1,
        // annualWages: 15000,
        officePack: false,
        shopPack: false,
        // occupationCode: 785401,
        // occupationDesc: 'Office',

        insuredPerson: '',
        insuredPersonBirthDate: '',

        locationAddress1: '',
        locationDistrict: '',
        locationDistrictDesc: '',
        locationPostCode: '',
        locationAccumulationRegister: '',
        locationUnitNo: '',
        locationFloorNo: '',
        locationBuildingName: '',
        locationBuildingStreetNo: '',
        locationCountry: 'SGP',

        // totalGrossAmount: 0,
        totalDiscount: 0,
        totalDueAmount: 590,
        subsidyAmount: 0,
        riskNumber: 0,
        applicant: {
            fullName: '',
            additionalName: '',
            mobileNo: '',
            email: '',
            uen: '',
            clientType: 'C',
            applicantAddress1: '',
            applicantDistrict: '',
            applicantDistrictDesc: '',
            applicantPostCode: '',
            applicantAccumulationRegister: '',
            applicantUnitNo: '',
            applicantFloorNo: '',
            applicantBuildingName: '',
            applicantBuildingStreetNo: '',
            forAttentionOf: '',

            sameAsInsuredAddress: true,
            hasInterestedParty: '',
            directMarketing: false
        },
        policyPremium: {
            premium: 0,
            annualPremium: 0,
            levy: 0,
            ecLevy: 0,
            totalPremium: 0,
            discount: 0,
            discountRate: 0,
            insuredCommissionDiscount: 0,
            insuredCommissionDiscountRate: 0
        },
        premiumItems: [
        ],
        interestedParty: {
            customerType: 'C'
        }
    }
}
